import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { addIncidenciaDeMaquina, removeIncidenciaDeMaquina, modifyIncidenciaMaquina } from '../../actions/maquina_incidencias_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaquinaIncidencias extends React.Component {


    addIncidencia = (incidencia) => {
        this.props.addIncidenciaDeMaquina(incidencia);
    };

    modifyIncidenciaMaquina = (incidencia) => {
        this.props.modifyIncidenciaMaquina(incidencia);
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };


    checkIncidenciaFields = incidencia => {
        if (incidencia.fecha < '1900-01-01T00:00:00') {
            this.messageDialog('Fecha de la incidencia inválida');
            return false;
        } else if (!incidencia.fecha) {
            this.messageDialog('Por favor, rellene el campo Fecha');
            return false;
        } else if (!incidencia.incidencia.trim()) {
            this.messageDialog('Por favor, rellene el campo Incidencia');
            return false;
        } else if (!incidencia.usuarioIncidencia) {
            this.messageDialog('Por favor, rellene el campo Usuario Incidencia');
            return false;
        } else if (incidencia.fechaDiagnostico && incidencia.fechaDiagnostico < '1900-01-01T00:00:00') {
            this.messageDialog('Fecha de diagnóstico inválida');
            return false;
        } else if (incidencia.fechaResolucion && incidencia.fechaResolucion < '1900-01-01T00:00:00') {
            this.messageDialog('Fecha de resolución inválida');
            return false;
        } else if ((incidencia.fechaResolucion && incidencia.fechaDiagnostico) && incidencia.fechaDiagnostico > incidencia.fechaResolucion) {
            this.messageDialog('Fecha de resolución debe ser posterior a la de diagnóstico');
            return false;
        }

        else return true;
    };

    newIncidencia = () => {

        this.props.openDialog('EditIncidenciaMaquina', {
            incidencia: {},
            maquinaId: this.props.id,
            okHandler: this.addIncidencia,
            checkIncidenciaFields: this.checkIncidenciaFields,
        }, uuidv4());

    };

    editIncidencia = (incidencia) => {

        this.props.openDialog('EditIncidenciaMaquina', {
            incidencia,
            maquinaId: this.props.id,
            okHandler: this.modifyIncidenciaMaquina,
            checkIncidenciaFields: this.checkIncidenciaFields,
        }, uuidv4());

    };

    removeIncidencia = (incidencia, index) => {
        this.props.removeIncidenciaDeMaquina(incidencia);
    };


    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Incidencias</Typography>

                {this.props.maquinaIncidencias && !this.props.isLoading ?
                <NeuriteGrid
                id="m_i"
                    columns={[
                        { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 80 },
                        { key: 'incidencia', name: 'Incidencia', editable: false, dragable: false, width: 74 },
                        { key: 'usuarioIncidencia', name: 'Usuario Incidencia', editable: false, dragable: false, width: 122  },
                        { key: 'fechaDiagnostico', name: 'Fecha Diagnostico', editable: false, dragable: false, type: 'date', width: 112 },
                        { key: 'diagnostico', name: 'Diagnostico', editable: false, dragable: false, width: 77 },
                        { key: 'usuarioDiagnostico', name: 'Usuario Diagnostico', editable: false, dragable: false, width: 123 },
                        { key: 'fechaResolucion', name: 'Fecha Resolucion', editable: false, dragable: false, type: 'date', width: 112 },
                        { key: 'resolucion', name: 'Resolucion', editable: false, dragable: false, width: 77 },
                        { key: 'usuarioResolucion', name: 'Usuario Resolucion', editable: false, dragable: false, width: 122 },

                    ]}
                    rows={this.props.maquinaIncidencias}
                    buttonEdit={false}
                    buttonDelete={false}
                    buttonNew={false}
                    height={200}
                />
                : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}

            </div>
        );
    };
};

MaquinaIncidencias.propTypes = {
    //state
    isLoading: PropTypes.bool.isRequired,
    maquinaIncidencias: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    addIncidenciaDeMaquina: PropTypes.func.isRequired,
    removeIncidenciaDeMaquina: PropTypes.func.isRequired,
    modifyIncidenciaMaquina: PropTypes.func.isRequired,
    //props:
    id: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        maquinaIncidencias: state.maquinaIncidencias.maquinaIncidencias,
        isLoading: state.maquinaIncidencias.isLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        addIncidenciaDeMaquina,
        removeIncidenciaDeMaquina,
        modifyIncidenciaMaquina,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaquinaIncidencias));